var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "baseInfoBox" }, [
    _c("div", { staticClass: "nyp-ai-box" }, [
      _c(
        "div",
        { staticClass: "line-box y-p-r" },
        [
          _vm._m(0),
          _c("div", { staticClass: "y-mb-24" }, [
            !_vm.tableData.length
              ? _c(
                  "div",
                  {
                    staticClass: "add-pro-style",
                    on: { click: _vm.addProductFn },
                  },
                  [
                    _c("span", { staticClass: "add" }, [_vm._v("+")]),
                    _c("div", { staticClass: "add-txt" }, [_vm._v("添加商品")]),
                  ]
                )
              : _c("div", { staticClass: "pro-img-style y-p-r y-f y-f-a" }, [
                  _c(
                    "div",
                    {
                      staticClass: "img",
                      on: {
                        mouseenter: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.isMousehover = true
                        },
                        mouseleave: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.isMousehover = false
                        },
                      },
                    },
                    [
                      _vm.tableData[0].imageUrl || _vm.tableData[0].productPic
                        ? _c("el-image", {
                            staticStyle: { width: "78px", height: "78px" },
                            attrs: {
                              scrollContainer: ".yto-x-auto",
                              lazy: "",
                              src:
                                _vm.tableData[0].imageUrl ||
                                _vm.tableData[0].productPic,
                              "preview-src-list": [
                                _vm.tableData[0].imageUrl ||
                                  _vm.tableData[0].productPic,
                              ],
                            },
                          })
                        : _vm._e(),
                      _vm.isMousehover && !_vm.disabledChange
                        ? _c(
                            "div",
                            {
                              staticClass: "y-p-a edit-box y-f y-f-a y-f-jc",
                              on: { click: _vm.addProductFn },
                            },
                            [
                              _c("div", { staticClass: "edit-img" }, [
                                _vm._v("编辑"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "proTxt" }, [
                    _c("div", [
                      _vm._v(
                        "商品名称：" + _vm._s(_vm.tableData[0].productName)
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "商品简称：" + _vm._s(_vm.tableData[0].productShortName)
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "商品编码：" + _vm._s(_vm.tableData[0].productCode)
                      ),
                    ]),
                  ]),
                ]),
          ]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.form, rules: _vm.rules, "label-width": "0" },
            },
            [
              _c("div", { staticClass: "tit-desp" }, [
                _vm._v("文案长度"),
                _c("span", { staticClass: "y-fc-F0484A" }, [_vm._v("*")]),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "y-mb-24",
                  attrs: { label: "", prop: "lengthCode" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "y-w-320",
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.lengthCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "lengthCode", $$v)
                        },
                        expression: "form.lengthCode",
                      },
                    },
                    [
                      _vm.productDescType == 1 ||
                      _vm.productDescType == 4 ||
                      _vm.productDescType == 111
                        ? _vm._l(_vm.xhsLengthList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.code },
                            })
                          })
                        : _vm._e(),
                      _vm.productDescType == 2 || _vm.productDescType == 222
                        ? _vm._l(_vm.lengthList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.code },
                            })
                          })
                        : _vm._e(),
                      _vm.productDescType == 3
                        ? _vm._l(_vm.titleLengthList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.code },
                            })
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "tit-desp" }, [_vm._v("参考文案")]),
              _c(
                "el-form-item",
                {
                  staticClass: "y-mb-24",
                  attrs: { label: "", prop: "referenceKey" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "200",
                      type: "textarea",
                      "show-word-limit": "",
                      placeholder: "请将需要参考的文案粘贴到此处",
                      rows: 8,
                    },
                    model: {
                      value: _vm.form.referenceKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "referenceKey", $$v)
                      },
                      expression: "form.referenceKey",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "tit-desp" }, [_vm._v("其他要求")]),
              _c(
                "el-form-item",
                {
                  staticClass: "y-mb-24",
                  attrs: { label: "", prop: "otherKey" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "200",
                      type: "textarea",
                      "show-word-limit": "",
                      placeholder: "如：“语气可爱一点”",
                      rows: 8,
                    },
                    model: {
                      value: _vm.form.otherKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "otherKey", $$v)
                      },
                      expression: "form.otherKey",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "y-mt-8" },
                    _vm._l(_vm.form.otherKeyTipList, function (item, ind) {
                      return _c(
                        "span",
                        {
                          key: ind,
                          staticClass: "form-tip",
                          class: {
                            active:
                              _vm.form.otherKey &&
                              _vm.form.otherKey.indexOf(item) > -1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.fillOtherKeyFn(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bottombox y-f y-f-a y-f-je" }, [
      _c("div", { staticClass: "clearBtn", on: { click: _vm.handleClose } }, [
        _c("i", { staticClass: "el-icon-delete y-mr-5" }),
        _vm._v("清空"),
      ]),
      _c("div", {
        staticClass: "confirmBtn",
        class: { disableStyle: !_vm.tableData.length || !_vm.form.lengthCode },
        domProps: { textContent: _vm._s(_vm.getBtnTxt()) },
        on: { click: _vm.reCreateFn },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tit-desp" }, [
      _vm._v("选择商品"),
      _c("span", { staticClass: "y-fc-F0484A" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }